import { createClient } from '@supabase/supabase-js'

// TODO: Replace these with your actual Supabase credentials
// You can either:
// 1. Replace the strings directly here
// 2. Or use Vite env vars: import.meta.env.VITE_SUPABASE_URL
const supabaseUrl = 'https://your-project.supabase.co'
const supabaseKey = 'your-anon-key-here'

export const supabase = createClient(supabaseUrl, supabaseKey)
